import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import firebaseConfig from '../../../firebase-config.json';

const firebaseApp = initializeApp(firebaseConfig);
export const database = getDatabase(firebaseApp);
